var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('section', {
    staticClass: "section"
  }, [_c('v-container', [_c('div', {
    staticClass: "section-title-wrap"
  }, [_c('h2', {
    staticClass: "client-title--xxxl"
  }, [_vm._v("발간자료실")])]), _c('div', {
    staticClass: "library-report"
  }, [_c('div', {
    staticClass: "library-report__inner"
  }, [_vm.board ? _c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-spacer'), _c('v-col', {
    attrs: {
      "cols": "5",
      "lg": "4"
    }
  }, [_c('v-img', {
    staticClass: "border-radius-16",
    attrs: {
      "src": _vm.board.thumb,
      "aspect-ratio": 1
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "7",
      "lg": "6"
    }
  }, [_c('v-row', {
    staticClass: "row--sm white--text"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('h3', {
    staticClass: "client-title--lg"
  }, [_vm._v(_vm._s(_vm.board.subject))])]), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "client-title--sm font-weight-regular"
  }, [_vm._v(_vm._s(_vm.board.summary))])]), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-sheet', {
    staticClass: "d-flex j",
    attrs: {
      "color": "transparent",
      "max-width": "416"
    }
  }, [_c('v-row', {
    staticClass: "row--sm",
    attrs: {
      "justify": "spaceBetween"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-btn', {
    attrs: {
      "block": "",
      "rounded": "pill",
      "large": "",
      "href": _vm.board.url,
      "target": "__blank"
    }
  }, [_c('span', {
    staticClass: "primary--text"
  }, [_vm._v(" 온라인 연차보고 "), _c('v-icon', {
    staticClass: "ml-10",
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-chevron-right")])], 1)])], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-btn', {
    attrs: {
      "block": "",
      "outlined": "",
      "color": "white",
      "rounded": "pill",
      "large": ""
    },
    on: {
      "click": function ($event) {
        var _vm$board, _vm$board$files$, _vm$board2, _vm$board2$files$;
        return _vm.download(`${(_vm$board = _vm.board) === null || _vm$board === void 0 ? void 0 : (_vm$board$files$ = _vm$board.files[0]) === null || _vm$board$files$ === void 0 ? void 0 : _vm$board$files$.url}`, `${(_vm$board2 = _vm.board) === null || _vm$board2 === void 0 ? void 0 : (_vm$board2$files$ = _vm$board2.files[0]) === null || _vm$board2$files$ === void 0 ? void 0 : _vm$board2$files$.fileName}`);
      }
    }
  }, [_vm._v(" PDF 보기 "), _c('v-icon', {
    staticClass: "ml-10",
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-chevron-right")])], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e()], 1)]), !_vm.$route.params._board && _vm.$route.query.mode !== 'input' ? [_c('board-list', {
    attrs: {
      "code": "library"
    }
  })] : _vm.$route.query.mode === 'input' ? _c('board-write') : _c('board-view')], 2)], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }